module.exports = __webpack_public_path__ + "components/country-flag/static/es-ga-30ec1c2025efb03f23219957b6b820ad.svg";